<template>
  <div>
    <apexchart
      class="apex-charts"
      height="230"
      dir="rtl"
      :series="series"
      :options="{ ...chartOptions, ...{ labels: labels } }"
    ></apexchart>
    <div class="row flex flex-wrap">
      <div :key="i" class="mx-2" v-for="(item, i) in series">
        <div class="text-center mt-4">
          <p class="mb-2 text-truncate">
            <i
              class="mdi mdi-circle font-size-10 mr-1"
              :style="{ color: chartOptions.colors[i] }"
            ></i>
            {{ labels[i] }}
          </p>
          <h5>
            {{
              item !== 0
                ? Math.round(
                    (item * 100) / $helper.calculateChartSeriesTotal(series)
                  )
                : 0
            }}%
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import chartOptions from '@/data/pie-chart-options'

export default {
  props: {
    applicationId: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      labels: [],
      series: [],
      chartOptions,
    }
  },
  methods: {
    async fetchData() {
      let route = `notifications/chart/group-by-status`
      if (this.applicationId) {
        route += '?application_id=' + this.applicationId
      }
      await this.$axios.get(route).then((res) => {
        const keys = Object.keys(res.data)
        keys.forEach((item) => {
          switch (item) {
            case 'send_notifications_count':
              this.labels.push('ارسال شده')
              break
            case 'not_send_notifications_count':
              this.labels.push('ارسال نشده')
              break
            case 'awaiting_approval_notifications_count':
              this.labels.push('در انتظار تایید')
              break
          }
        })
        this.series = Object.values(res.data)
      })
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>
